<template>
	<div class="page">
		<img :src="headImg" v-if="headImg" class="bg" alt="" />
		<div class="imgList w1200">
			<!-- <image v-for="(item, index) in imgList" :key="index" :src="item.PtSrc" class="img" mode="widthFix"></image> -->
			<!--  -->
			<div class="agenda">
				<div class="title">
					{{ lan=="en"?MtsETitle:MtsTitle }}
				</div>
				<div class="data fl_center">
					<img src="@/assets/time.png" class="icon" alt="">
					<div class="sub_tit">
						{{ MtsStartTime }}
					</div>
				</div>
				<div class="address fl_center">
					<img src="@/assets/address.png" class="icon" alt="">
					<div class="sub_tit">
						{{ lan=="en"?MtsEArea:MtsArea }}
					</div>
				</div>
			</div>
			<!--  -->
			<div class="details">
				<div v-for="(item, index) in list" class="details_con" :key="index">
					<div class="details_left">
						<div class="start">
							{{ item.MsStartTime.slice(0, 5) }}
						</div>
						-
						<div class="end">
							{{ item.MsEndTime.slice(0, 5) }}
						</div>
					</div>
					<div class="round fl_center">
						<div class="round_con"> </div>
						<div class="round_bor"> </div>
					</div>
					<div class="details_right">
						<div class="title">
							{{ lan=="en"?item.MsETitle:item.MsTitle }}
						</div>
						<div class="sub_tit">
							{{ lan=="en"?item.MsPsnEName:item.MsPsnName }}
						</div>
						<div class="sub_tit">
							{{ lan=="en"?item.MsPsnERank:item.MsPsnRank }}
						</div>
						<div class="sub_tit">
							{{ lan=="en"?item.MsPsnECompany:item.MsPsnCompany }}
						</div>
					</div>
				</div>
			</div>
			<!--  -->
			<div class="btn fl_center" @click="bindBack">
				{{ lan=="en"?"Back":"返回" }}
			</div>
		</div>
	</div>
</template>

<script>
	import {
		isMobileDevice
	} from "@/utils/deviceCheck";
	export default {
		name: "Details",
		data() {
			return {
				companyName: "",
				name: "",
				list: [],
				borderTop: true,
				bottomHight: "",
				inactiveColor: "#999999",
				activeColor: "#333333",
				headImg: '',
				flag: false,
				headerImg: "",
				page: 1,
				limit: 10,
				exhid: '',
				phoneNumber: "",
				email: "",
				MtsArea: "",
				MtsStartTime: "",
				MtsTitle: "",
				MtsETitle: "",
				MtsEArea: "",
				MtsID: "",
				regUrl: '',
				lan: "", // lan=en 的参数来显示英文
				MettingRegUrl: "",
			};
		},
		created() {
			console.log("调用获取id的方法", this.$route.query);
			if (this.$route.query) {
				this.exhid = this.$route.query.exhid;
				this.MtID = this.$route.query.MtID;
				this.lan = this.$route.query.lan;
				if (isMobileDevice()) {
					window.location.href =
						`https://hkh5.eainfor.com/#/pages/exhibition/details?exhid=${this.$route.query.exhid}&MtID=${this.$route.query.MtID}`;
				}
				setTimeout(() => {
					this.getImg();
					this.getMettingDetail(this.$route.query.MtID);
				}, 200);
			}
		},
		mounted() {},
		methods: {
			getImg() {
				let that = this;
				let url = `/Exh/resourceUrl/${that.exhid}?type=1`;
				this.$http
					.get(url, {
						headers: {
							"content-type": "application/json",
						},
					})
					.then((res) => {
						console.log("获取图片", res);
						that.headImg = res.data.data.pc_banner;
						document.title = res.data.data.title ? res.data.data.title : '';
					})
					.catch((error) => {
						this.$message.error(error);
					});
			},
			//获取日程
			getMettingDetail(MtID) {
				let that = this;
				let url = `/Api/mettingDetail/${that.exhid}?MtsID=${MtID}`;
				this.$http
					.get(url, {
						headers: {
							"content-type": "application/json",
						},
					})
					.then((res) => {
						let _data = res.data.data;
						that.MtsArea = _data.MtsArea;
						that.MtsStartTime = _data.MtsStartTime;
						that.MtsTitle = _data.MtsTitle;
						that.MtsETitle = _data.MtsETitle;
						that.MtsEArea = _data.MtsEArea;
						that.list = _data.schedules;
						console.log('会议分组列表res', _data)

					})
					.catch((error) => {
						this.$message.error(error);
					});
			},
			bindBack() {
				this.$router.go(-1);
			},


		},
	};
</script>

<style lang="less" scoped>
	.page {
		background: #f6f6f6;
		position: absolute;
		width: 100%;
		min-height: 100%;
	}

	.fl_center {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.bg {
		display: block;
		width: 100%;
	}

	.agenda {
		width: 1115px;
		height: 282px;
		background: url('../assets/bg3.png') no-repeat;
		background-size: 100% 100%;
		border-radius: 20px;
		display: flex;
		align-items: flex-start;
		justify-content: center;
		flex-direction: column;
		padding-left: 85px;
		margin: 0 auto;
		margin-top: 50px;

		.title {
			font-weight: 500;
			font-size: 30px;
			color: #1C1D31;
			line-height: 80px;
		}

		.data {
			font-weight: 400;
			font-size: 30px;
			color: #1C1D31;
			line-height: 80px;

			.icon {
				width: 27px;
				height: 27px;
				margin-right: 52px;
			}
		}

		.address {
			font-weight: 400;
			font-size: 30px;
			color: #1C1D31;
			line-height: 80px;

			.icon {
				width: 23px;
				height: 36px;
				margin-right: 52px;
			}
		}
	}

	.details {

		width: 1200px;
		min-height: 951px;
		background: url('../assets/bg4.png') no-repeat;
		background-size: 100% 100%;
		border-radius: 20px;
		padding-top: 112px;
		padding-bottom: 116px;
		margin-top: 44px;

		.details_con {
			display: flex;
			height: 238px;
		}

		.details_left {
			padding-left: 246px;
			display: flex;
			flex-direction: column;
			align-items: center;

			.start {
				font-weight: 400;
				font-size: 30px;
				color: #ffffff;
				line-height: 40px;
			}

			.end {
				font-size: 30px;
				color: #ffffff;
				line-height: 40px;
				opacity: 0.6;
			}

			color: #ffffff;
		}

		.round {
			width: 64px;
			height: 64px;
			position: relative;

			.round_con {
				width: 11px;
				height: 11px;
				background: #10AFF8;
				border-radius: 50%;
				z-index: 9;
			}

			.round_bor {
				position: absolute;
				top: -202px;
				left: 32px;
				border-right: 1px solid #5e31ee;
				height: 238px;
				z-index: 8;
			}
		}

		.details_con:first-child {
			.round {
				.round_bor {
					height: 0px;
				}
			}
		}

		// .round::after {
		// 	content: "";
		// 	position: absolute;
		// 	top: -176px;
		// 	left: 16px;
		// 	border-right: 0.5px solid #5E31EE;
		// 	height: 192px;
		// }

		.details_right {
			padding-left: 69px;

			.title {
				font-weight: 400;
				font-size: 30px;
				color: #ffffff;
				line-height: 40px;
				margin-bottom: 26px;
			}

			.sub_tit {
				font-weight: 400;
				font-size: 26px;
				color: #9f9fa1;
				line-height: 40px;
			}
		}
	}

	.btn {
		width: 378px;
		height: 64px;
		background: #4E15FF;
		border-radius: 6px;
		font-weight: 500;
		font-size: 30px;
		color: #FFFEFE;
		margin: 0 auto;
		text-align: center;
		line-height: 64px;
		margin-top: 50px;
		margin-bottom: 109px;


	}
</style>